import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/icon/iconfont.css'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import "video.js/dist/video-js.css";
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)
document.title='读书郎-物料管理平台'
Vue.use(VideoPlayer)
Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
